import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function DigitalFlyer() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デジタルチラシ掲載について
          </Typography>
          デジタルチラシの掲載対象は、一日の新聞折り込み数が３万部以上の大口のお得意さまで、掲載は無料です。紙のチラシを折り込む一方で、デジタルの付加価値がプラスされるというイメージです。この機会にぜひご活用ください。<br/>
          チラシデータ入稿（折込チラシと締切日時は同じです）<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/pdf/flyer/guide_digitalflyer.pdf" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  デジタルチラシのご案内
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お申込み方法
          </Typography>
          デーリー東北折込センターへお問い合わせください。<br/>
          <PhoneEnabledIcon /> 0178-46-3195<br/>
          <i className="fas fa-fax mx-1"></i> 0178-44-1734<br/>
          <MailOutlineIcon /> <a href="mailto:orikomi@daily-tohoku.co.jp">orikomi@daily-tohoku.co.jp</a><br/>
          <br/>
          専用入稿フォームからお申込みいただけます。<br/>
          <a href="https://www.dt-flyer.com/">https://www.dt-flyer.com/</a><br/>
          ※初回ご利用時にＩＤ、パスワードをご用意しお知らせいたします。<br/>
        </Box>

        <Box my={8}>
          <Paper>
            <Box p={3} textAlign="center">
              <Grid spacing={0} container direction="row" justify="left">
                <Grid item xs={12} className="p-2">
                  <img src="/images/ad/ad_digital_flyer01.png" className="img-fluid" />
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Box>

      </div>
    </div>
  );
}

export default DigitalFlyer;
